/**
 * Tegels boven de lijst (motor 7 golf 2, sessie D; keuze 1 van 75, mock v10).
 *
 * Rij 1: vier tegels in twee rijen van twee, Voor jou, Nakijken, Wacht en
 * Afgerond. Alleen een getal en het woord, geen subtekst. Een klik kiest de
 * tegel; de lijst toont dan alleen die kaarten.
 *
 * Rij 2: de kanalen plus Beloftes, klein, met het aantal binnen de gekozen
 * tegel. Een klik filtert, nog eens klikken is alles. Een knipperende stip als
 * Nova in dat kanaal live bezig is.
 */
import { KANAAL_WOORD, KANALEN, type Kanaal, type Tegel } from "../api";
import { Icoon } from "../Icoon";

import { KANAAL_ICOON, KANAAL_KLASSE, type TegelTellers } from "./hulp";

export const TEGELS: { tegel: Tegel; woord: string }[] = [
  { tegel: "voor_jou", woord: "Voor jou" },
  { tegel: "nakijken", woord: "Nakijken" },
  { tegel: "wacht", woord: "Wacht" },
  { tegel: "afgerond", woord: "Afgerond" },
];

export function Tegels({
  tellers,
  gekozen,
  onKies,
}: {
  tellers: TegelTellers | null;
  gekozen: Tegel | null;
  onKies: (tegel: Tegel) => void;
}) {
  return (
    <div className="v6-tegels4" role="group" aria-label="Tegels">
      {TEGELS.map(({ tegel, woord }) => {
        const aan = gekozen === tegel;
        const aantal = tellers?.[tegel];
        return (
          <button
            key={tegel}
            type="button"
            className={`v6-tegel4 ${tegel}${aan ? " on" : ""}`}
            aria-pressed={aan}
            data-testid={`tegel-${tegel}`}
            title={`${woord}: ${aantal ?? "laden"}`}
            onClick={() => onKies(tegel)}
          >
            <span className="n num">{aantal ?? ""}</span>
            <span className="w">{woord}</span>
          </button>
        );
      })}
    </div>
  );
}

export function KanaalFilter({
  tellers,
  kanaal,
  beloftes,
  liveKanalen,
  onKanaal,
  onBeloftes,
}: {
  tellers: Record<Kanaal | "beloftes", number> | null;
  kanaal: Kanaal | null;
  beloftes: boolean;
  liveKanalen: Set<Kanaal>;
  onKanaal: (kanaal: Kanaal) => void;
  onBeloftes: () => void;
}) {
  return (
    <div className="v6-kanaalrij" role="group" aria-label="Kanalen">
      {KANALEN.map((k) => {
        const aan = kanaal === k;
        const live = liveKanalen.has(k);
        const aantal = tellers?.[k] ?? 0;
        return (
          <button
            key={k}
            type="button"
            className={`v6-pil ${KANAAL_KLASSE[k]}${aan ? " on" : ""}`}
            aria-pressed={aan}
            data-testid={`kanaal-${k}`}
            title={`${KANAAL_WOORD[k]}: ${aantal}${live ? ", live" : ""}`}
            onClick={() => onKanaal(k)}
          >
            {live ? <span className="live" aria-hidden="true" /> : null}
            <span className="b">
              <span className={`ic ${KANAAL_KLASSE[k]}`}>
                <Icoon naam={KANAAL_ICOON[k]} klein />
              </span>
              <span className="num">{tellers ? aantal : ""}</span>
            </span>
            <span className="w">{KANAAL_WOORD[k]}</span>
          </button>
        );
      })}
      <button
        type="button"
        className={`v6-pil belofte${beloftes ? " on" : ""}`}
        aria-pressed={beloftes}
        data-testid="kanaal-beloftes"
        title={`Beloftes: ${tellers?.beloftes ?? 0}`}
        onClick={onBeloftes}
      >
        <span className="b">
          <span className="ic belofte">
            <Icoon naam="lijstje" klein />
          </span>
          <span className="num">{tellers ? tellers.beloftes : ""}</span>
        </span>
        <span className="w">Beloftes</span>
      </button>
    </div>
  );
}
